var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"absolute","z-index":"100"}},[_c('v-btn',{on:{"click":function($event){return _vm.update_assets()}}},[_vm._v(" update ")])],1),_c('div',{staticClass:"basemap",attrs:{"id":"mapContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }